/** Pure barrel — re-exports only side-effect-free modules */
export * from "./nativeXRRenderTarget";
export * from "./nativeXRFrame.pure";
